import appsSagas from './apps/sagas';

export default [
  ...appsSagas,
];
